import { RouteObject } from 'react-router-dom';
import { FeatureCreateJob } from './feature-create-job';
import { FeatureCopyJob } from './feature-copy-job';
import { FeatureEditJob } from './feature-edit-job';
import { FeatureJobApplicants } from './feature-job-applicants';

import { CandidateAppliedView } from './candidate-views/feature-candidate-applied-view';
import { FavouriteListProfile } from './candidate-views/feature-favorite-profile';
import { SimpleCV } from './candidate-views/feature-simple-cv';
import { FavouriteList } from './favorites-page';
import { ViewCV } from './candidate-views/feature-view-cv';
import { PaymentHistory } from './feature-payment-history';
import { FeatureJobsBrowser } from './feature-jobs-browser';

export const EMPLOYER_ROUTES: RouteObject[] = [
   {
      path: '/user/managejob',
      Component: FeatureJobsBrowser,
   },
   {
      path: '/user/createjob',
      Component: FeatureCreateJob,
   },
   {
      path: '/user/copy-job/:slug',
      Component: FeatureCopyJob,
   },
   {
      path: '/job/edit/:slug',
      Component: FeatureEditJob,
   },
   {
      path: '/user/managejob/accdetail/:slug',
      Component: FeatureJobApplicants,
   },
   {
      path: '/user/favouritelist',
      Component: FavouriteList,
   },

   {
      path: '/user/paymenthistory',
      Component: PaymentHistory,
   },

   /** Candidate info view =--------------------------------- */

   {
      path: '/candidates/simple-cv/:id',
      Component: SimpleCV,
   },
   {
      path: '/candidates/applied-candidate-info/:id',
      Component: CandidateAppliedView,
   },
   {
      path: '/candidates/profile/:slug',
      Component: FavouriteListProfile,
   },
   {
      path: '/candidates/listing/:id',
      Component: ViewCV,
   },

   /** Candidate info view =--------------------------------- */
];
